// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"no2eha3Yhq-B1-Jcx5b5q","login-row":"w2nFHBCwqeC_H4VD1XcKY","statustext":"_37napZRvlDTtfzg3jasQta","errortext":"_1NkHM28hjg7Aw48V6j5v6z","loadingtext":"_2kOmM3ODAxHxLHzmlrZ9_O","forgot-password":"X-ygJ_wrqfpZm_Kn_Wens","forgot-password-btn":"Kh3Cy44SYm05K7wMRUBeC","passwordSuccessResetBanner":"AvxtBkZSY3wbG_jRiIwt9"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/auth/GenericLoginPage.less
 ** module id = 860
 ** module chunks = 0
 **/